import { environment } from "../../../environments/environment";

export const ApiUrlConstants = {
    getUserDetails: "/dashboard/getAdminDashboardUsersDetail",

  //#region User routes
  ResendTemporaryPassword: "/users/resendTemporaryPassword",

  currentUserLogin: "/users/login",

  resetUserPassword: "/users/resetUserPassword",

  forgotPassword: "/users/forgotPassword",

  setNewPasswordFromForgot: "/users/newPassword",
 
  GetUserDetailByToken: "/users/getDetailsByTokenId",

  LogoutCurrentUser: "/users/logout",

  getLoginUserDetails: "/users/getDetails",

  GetUserCategories: "/userCategories",

  /** Get user detail by logged user's email. */
  GetUserDetailByEmail: "/users/getDetailsByEmail",
  //#endregion

  //#region Category Master routes
  CategoryMasterBase: "/category-master",
  CategoryMasterPreviewCode: "/category-master/preview-code",
  CategoryMasterRestore: "/category-master/restore",
  CategoryMasterSearch: "/category-master/search",
  CategoryMasterExportExcel: "/category-master/export/excel",
  CategoryMasterTemplateDownload: "/category-master/template/download",
  CategoryMasterImportExcel: "/category-master/import/excel",
  //#endregion

  //#region Organization Hierarchy routes
  OrgHierarchyBase: "/org-hierarchy",
  OrgHierarchyRestore: "/org-hierarchy/restore",
  OrgHierarchySearch: "/org-hierarchy/search",
  OrgHierarchyExportExcel: "/org-hierarchy/export/excel",
  OrgHierarchyTemplateDownload: "/org-hierarchy/template/download",
  OrgHierarchyImportExcel: "/org-hierarchy/import/excel",
  //#endregion

  //#region Entity Master routes
  EntityMasterBase: "/entity-master",
  EntityMasterRestore: "/entity-master/restore",
  EntityMasterSearch: "/entity-master/search",
  EntityMasterExportExcel: "/entity-master/export/excel",
  EntityMasterTemplateDownload: "/entity-master/template/download",
  EntityMasterImportExcel: "/entity-master/import/excel",
  //#endregion

  //#region Facility Master routes
  FacilityMasterBase: "/facility-master",
  FacilityMasterRestore: "/facility-master/restore",
  FacilityMasterSearch: "/facility-master/search",
  FacilityMasterExportExcel: "/facility-master/export/excel",
  FacilityMasterTemplateDownload: "/facility-master/template/download",
  FacilityMasterImportExcel: "/facility-master/import/excel",
  //#endregion

  //#region Asset Type Master routes
  AssetTypeMasterBase: "/asset-type-master",
  AssetTypeMasterRestore: "/asset-type-master/restore",
  AssetTypeMasterSearch: "/asset-type-master/search",
  AssetTypeMasterExportExcel: "/asset-type-master/export/excel",
  AssetTypeMasterTemplateDownload: "/asset-type-master/template/download",
  AssetTypeMasterImportExcel: "/asset-type-master/import/excel",
  //#endregion

  //#region Fuel Type Master routes
  FuelTypeMasterBase: "/fuel-type-master",
  FuelTypeMasterRestore: "/fuel-type-master/restore",
  FuelTypeMasterSearch: "/fuel-type-master/search",
  FuelTypeMasterExportExcel: "/fuel-type-master/export/excel",
  FuelTypeMasterTemplateDownload: "/fuel-type-master/template/download",
  FuelTypeMasterImportExcel: "/fuel-type-master/import/excel",
  //#endregion

  //#region Asset Source Master routes
  AssetSourceMasterBase: "/asset-source-master",
  AssetSourceMasterRestore: "/asset-source-master/restore",
  AssetSourceMasterSearch: "/asset-source-master/search",
  AssetSourceMasterExportExcel: "/asset-source-master/export/excel",
  AssetSourceMasterTemplateDownload: "/asset-source-master/template/download",
  AssetSourceMasterImportExcel: "/asset-source-master/import/excel",
  //#endregion

  //#region Activity Based Calculations routes
  ActivityBasedCalculationsBase: "/activity-based-calculations",
  ActivityBasedCalculationsRestore: "/activity-based-calculations/restore",
  ActivityBasedCalculationsSearch: "/activity-based-calculations/search",
  ActivityBasedCalculationsExportExcel: "/activity-based-calculations/export/excel",
  ActivityBasedCalculationsTemplateDownload: "/activity-based-calculations/template/download",
  ActivityBasedCalculationsImportExcel: "/activity-based-calculations/import/excel",
  //#endregion

  //#region Spend Based Calculations routes
  SpendBasedCalculationsBase: "/spend-based-calculations",
  SpendBasedCalculationsRestore: "/spend-based-calculations/restore",
  SpendBasedCalculationsSearch: "/spend-based-calculations/search",
  SpendBasedCalculationsExportExcel: "/spend-based-calculations/export/excel",
  SpendBasedCalculationsTemplateDownload: "/spend-based-calculations/template/download",
  SpendBasedCalculationsImportExcel: "/spend-based-calculations/import/excel",
  //#endregion
};
